import { Component } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';

@Block() @Component
export class PageMetaBlock extends BaseBlock {
	mounted() {
		const mainScript = this.getText('page-main-script');
		const scripts = this.getText('page-scripts').split(';');

		Promise.all(scripts.map(i => this.loadScript(i))).then(() => {
			const script = document.createElement('script');
			script.src = mainScript;
			document.head.appendChild(script);
		})
	}

	loadScript(src: string) {
	return new Promise((resolve, reject) => {
		const script = document.createElement('script');
		script.src = src.replace(/[\n\r]/g, '').trim();

		script.onload = () => resolve(script);
		script.onerror = () => reject(console.log(`Script load error for ${src}`));

		document.head.appendChild(script);
	}).then(() => console.log("Script loaded"));
}
}

export default PageMetaBlock;
